import SharedNote from './SharedNote';
import List from './List';

export { SharedNote, List };
export default SharedNote;



// WEBPACK FOOTER //
// ./src/components/SharedNote/index.js